module.exports = __webpack_public_path__ + "static/media/ambulance.336fd1a5.svg";